import Form from 'mobx-react-form';
import enLang from 'validatorjs/src/lang/en';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

const plugins = {
	dvr: dvr({
		package: validatorjs,
		extend: ({ validator }) => {
			validator.setMessages('en', enLang);

			const messages = validator.getMessages('en');
			messages.required = 'This field is required.';
			validator.setMessages('en', messages);
		},
	}),
};

const fields = {
	contactMode: {
		label: 'Billing contact mode',
		value: 'custom',
	},
	email: {
		label: 'Email',
		rules: 'string|required|email',
		placeholder: 'Billing email',
	},
	firstName: {
		label: 'First name',
		rules: 'string|between:0,150',
		placeholder: 'First name',
	},
	lastName: {
		label: 'Last name',
		rules: 'string|between:0,150',
		placeholder: 'Last name',
	},
};

class BillingForm extends Form {
	constructor(setup, options) {
		super({ fields, ...setup }, { plugins, ...options });
	}
}

export default BillingForm;
